module.exports = __webpack_public_path__ + "img/hist_gray.52f235dc.png";